import React from 'react';
import { Dropdown, Grid } from 'semantic-ui-react'
import Add from './add';
import $ from "jquery";
import Server from '../../functions/server';
import Executiveticket from './executiveticket';
import Viewall from './viewall';
import Createdticket from './createdticket';

class View extends React.Component {

  state = {
    selectedStatus: 'All',
    status1: 'All'
  }

  status = (f, { value }) => {
    this.setState({ selectedStatus: value });
  }

  status1 = (f, { value }) => {
    this.setState({ status1: value });
  }

  render() {

    let menuOption = [
      { key: 'All', text: 'All', value: 'All' },
      { key: 'Created Ticket', text: 'Created Ticket', value: 'Created Ticket' },
      { key: 'Executive Ticket', text: 'Executive Ticket', value: 'Executive Ticket' },
    ]

    let statusOption = [
      { key: 'All', text: 'All', value: 'All' },
      { key: 'Pending', text: 'Pending', value: 'Pending' },
      { key: 'Processing', text: 'Processing', value: 'Processing' },
    ]

    let view = (<div></div>);
    if (this.state.selectedStatus == 'All') {
      view = (<Viewall data={this.props.data} status1={this.state.status1} /> )
    }
    else if (this.state.selectedStatus == 'Created Ticket') {
      view = (<Createdticket getTickets={this.props.getTickets} status1={this.state.status1}
                  data={this.props.data} update={this.props.update}
                  userId={this.props.userId} ticketeditcontrol={this.props.ticketeditcontrol} />);
    }
    else {
      view = (<Executiveticket getTickets={this.props.getTickets}
                data={this.props.data} update={this.props.update} status1={this.state.status1}
                userId={this.props.userId} ticketeditcontrol={this.props.ticketeditcontrol} />);
    }
    return (
      <div>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <div style={{display: 'flex'}}>
              <Add getTickets={this.props.getTickets} type="add" title="Create Ticket" ticketeditcontrol={true} />
              <Dropdown id="Control" onChange={this.status} search selection options={menuOption}
                value={this.state.selectedStatus} style={{ borderColor: '#5A9CBB', fontSize: 12 }} />
              <Dropdown id="Control" onChange={this.status1} search selection options={statusOption}
                value={this.state.status1} style={{ borderColor: '#5A9CBB', fontSize: 12 }} />
            </div>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            {view}
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default View;
